import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContenForLossExcessReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import rowGroup from 'datatables.net-rowgroup';
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { lossExcessReportSchemaObject } from '../lossExcessReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _, { isNumber } from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import moment from 'moment';

const screenCode = "DAILYLOSSEXCESSREPORT";

export function LossExcessListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState();

    const [isTableHide, setIsTableHide] = useState(true);

    const [dailyLossExcess, setDailyLossExcess] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fieldID: "0",
        searchDate: "",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        field: "",
        searchDate: "",
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(lossExcessReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["fieldName", "session", "pluckingCheckrollWeight", "factoryTotal", "lossGain"];
    let pluckingDeductions = [];
    const [csvHeaders, setCsvHeaders] = useState([
        { label: "Field Name", value: "fieldName" },
        { label: "Session", value: "session" },
        { label: "Plucking Checkroll Weight", value: "pluckingCheckrollWeight" },
        { label: "Factory Weight", value: "factoryTotal" },
        { label: "Loss/ Gain", value: "lossGain" }
    ]);

    const [totalCollections, setTotalCollections] = useState({
        pluckingCheckrollWeight: 0,
        factoryTotal: 0,
        lossGain: 0
    });
    const [reportData, setReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [dailyLossExcess.groupID])

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown()
        )
    }, [dailyLossExcess.estateID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint()
        )
    }, [dailyLossExcess.divisionID]);

    function handleGroupChange(target) {
        validateInputs(target);

        setDailyLossExcess({
            ...dailyLossExcess,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0"
        });
        clearTable();
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setDailyLossExcess({
            ...dailyLossExcess,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0"
        });
        clearTable();
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setDailyLossExcess({
            ...dailyLossExcess,
            divisionID: target.value,
            fieldID: "0"
        });
        clearTable();
    }

    function handleFieldChange(target) {
        validateInputs(target);

        setDailyLossExcess({
            ...dailyLossExcess,
            fieldID: target.value
        });
        clearTable();
    }

    function handleSearchDateChange(target) {
        validateInputs(target);

        setDailyLossExcess({
            ...dailyLossExcess,
            searchDate: target.value
        });
        clearTable();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, lossExcessReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYLOSSEXCESSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setDailyLossExcess({
            ...dailyLossExcess,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(parseInt(dailyLossExcess.groupID));
        setEstates(data);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(parseInt(dailyLossExcess.estateID));
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetFieldsByCollectionPointID(parseInt(dailyLossExcess.divisionID));
        setFields(fields);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        e.preventDefault();

        setIsTableHide(true);
        setButtonHide(true);

        const errorMessages = validate(schema, dailyLossExcess);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getLossExcessReportData(dailyLossExcess);

        var mergedFactoryData = mergeFactroyDataBySession(result.factoryData);
        var mergedpluckingData = mergePluckingDataBySession(result.pluckingData);

        var mergeFactoryAndPluckingData = mergeFactoryAndPluckingDataBySession(mergedFactoryData, mergedpluckingData);

        if (mergeFactoryAndPluckingData.length > 0) {
            setReportData(mergeFactoryAndPluckingData);
            setIsTableHide(false);
            setButtonHide(false);
            createDataTable(['#example3', '#pdfTable']);
            getSelectedDropdownValuesForReport();
        }
    }

    function mergeFactoryAndPluckingDataBySession(factoryData, pluckingData) {
        var result = [];
        var totalData = {
            pluckingCheckrollWeight: 0,
            factoryTotal: 0,
            lossGain: 0
        };

        var merged = _.merge(_.keyBy(factoryData, 'factoryMobileSubSessionID'), _.keyBy(pluckingData, 'mobileSubSessionID'));

        Object.keys(merged).forEach(x => {
            merged[x].lossGain = checkUndifined(merged[x].factoryTotal)
                - checkUndifined(merged[x].pluckingCheckrollWeight);
            result.push(merged[x]);
        });

        result.forEach(x => {
            totalData.pluckingCheckrollWeight += checkUndifined(x.pluckingCheckrollWeight);
            totalData.factoryTotal += checkUndifined(x.factoryTotal);
            totalData.lossGain += checkUndifined(x.lossGain);
        });

        setTotalCollections({
            ...totalCollections,
            pluckingCheckrollWeight: totalData.pluckingCheckrollWeight,
            factoryTotal: totalData.factoryTotal,
            lossGain: totalData.lossGain
        });

        createCsvFile(result, totalData);

        return result;
    }

    function mergePluckingDataBySession(data) {
        var result = [];

        data.forEach(x => {
            if (result.length === 0) {
                result.push(generatePluckingRecord(x));
            } else {
                var duplicateSession = result.find(y =>
                    y.mobileSubSessionID === x.mobileSubSessionID);

                if (!duplicateSession) {
                    result.push(generatePluckingRecord(x));
                } else {
                    duplicateSession.pluckingCheckrollWeight = checkUndifined(duplicateSession.pluckingCheckrollWeight)
                        + checkUndifined(x.pluckingCheckrollWeight)
                }
            }
        });

        return result;
    }

    function mergeFactroyDataBySession(data) {
        var result = [];

        data.forEach(x => {
            if (result.length === 0) {
                result.push(x);
            } else {
                var duplicateSession = result.find(y =>
                    y.factoryMobileSubSessionID === x.factoryMobileSubSessionID);

                if (!duplicateSession) {
                    result.push(x);
                } else {
                    duplicateSession.factoryTotal = checkUndifined(duplicateSession.factoryTotal)
                        + checkUndifined(x.factoryTotal)
                }
            }
        });

        return result;
    }

    function generatePluckingRecord(data) {
        return {
            fieldID: data.fieldID,
            fieldName: data.fieldName,
            mobileSubSessionID: data.mobileSubSessionID,
            pluckingCheckrollWeight: data.pluckingCheckrollWeight,
            session: data.sessionName
                + " " + moment(data.startTime.split('T')[1].split('.')[0], ["HH.mm"]).format("hh:mm a")
        }
    }

    function checkUndifined(value) {
        if (value === undefined) {
            return 0;
        } else {
            return parseFloat(value);
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Divison Summary Report',
            fileName: 'DivisonSummaryReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            fieldName: "Group :" + groups[dailyLossExcess.groupID],
            session: "Estate : " + estates[dailyLossExcess.estateID],
            pluckingCheckrollWeight: "Division : " +divisions[dailyLossExcess.divisionID],
            factoryTotal: "Field : " + fields[dailyLossExcess.fieldID],
            lossGain: "Search Date : " + dailyLossExcess.searchDate
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function createCsvFile(data, total) {
        var copyOfData = _.cloneDeep(data);

        copyOfData.push({
            fieldName: "Total",
            pluckingCheckrollWeight: total.pluckingCheckrollWeight,
            factoryTotal: total.factoryTotal,
            lossGain: total.lossGain
        })

        setCsvData(copyOfData);
    }

    function createDataTable(dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#pdfTable' ? true : false,
                searching: x === '#pdfTable' ? false : true,
                paging: x === '#pdfTable' ? false : true,
                order: [[1, 'asc']]
            }).columns.adjust();
        })
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setDailyLossExcess({
            ...dailyLossExcess,
            divisionID: "0",
            fieldID: "0",
            searchDate: "",
        });
        setErrors("");
        clearTable();
    }

    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
    }


    function getSelectedDropdownValuesForReport() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[dailyLossExcess.groupID],
            estate: estates[dailyLossExcess.estateID],
            division: divisions[dailyLossExcess.divisionID],
            field: fields[dailyLossExcess.fieldID],
            searchDate: dailyLossExcess.searchDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Daily Loss/Excess Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyLossExcess.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyLossExcess.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Division *</InputLabel>
                                        <Select fullWidth
                                            id="divisionID"
                                            name="divisionID"
                                            value={dailyLossExcess.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select fullWidth
                                            id="fieldID"
                                            name="fieldID"
                                            value={dailyLossExcess.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)}>
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Search Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchDate"
                                            name="searchDate"
                                            type="date"
                                            onInput={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, dailyLossExcess)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="example3" className="display dataTable no-footer">
                                                    <thead>
                                                        <tr>
                                                            <th > Field Name </th>
                                                            <th > Session </th>
                                                            <th > Checkroll Weight </th>
                                                            <th > Factory Weight </th>
                                                            <th > Loss/ Gain </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContenForLossExcessReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="2"><b>Total</b></td>
                                                            <td style={{ textAlign: "right" }}>
                                                                <b>{totalCollections.pluckingCheckrollWeight.toFixed(2)}</b></td>
                                                            <td style={{ textAlign: "right" }}>
                                                                <b>{totalCollections.factoryTotal.toFixed(2)}</b></td>
                                                            <td style={{ textAlign: "right" }}>
                                                                <b>
                                                                    <h5><span class={totalCollections.lossGain > 0
                                                                        ? "badge badge-primary" : "badge badge-danger"}>{totalCollections.lossGain.toFixed(2)}
                                                                    </span></h5>
                                                                </b>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Divison Summary Report"}
                                            trigger={() => <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} dynamicContentRowNames={contentRowNames}
                                            rowNames={contentRowNames} searchData={selectedSearchValues}
                                            totalAmount={totalCollections} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
